import { ChainConfig, TokenInfo } from '../types';
import ShidoBridgeABI from './ShidoBridge.abi.json';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const SHIDO_TOKEN_META = {
  name: 'Shido',
  symbol: 'SHIDO',
  decimals: 18
};

export const CHAIN_CONFIGS: Record<string, ChainConfig> = {
  'shido-mainnet': {
    name: 'Shido Network',
    chainId: '0x2330', // 9008
    rpcUrl: 'https://evm.shidoscan.net',
    fallbackRpcUrls: [
      'https://evm.mavnode.io',
      'https://shido-testnet-archive-lb-q1ifr9jpz.zeeve.net/USjg7xqUmCZ4wCsqEOOE/rpc'
    ],
    bip44ChainId: 1073741856,
    SHIDO: ZERO_ADDRESS, // native SHIDO
    decimals: 18,
    bridge: "0x1193705f7ECd58f5B7f76FE77CC83255e4937d9D",
    icon: '/images/wshido.png',
    explorerUrl: 'https://shidoscan.net',
    nativeCurrency: {
      name: 'Shido',
      symbol: 'SHIDO',
      decimals: 18
    }
  },
  'ethereum': {
    name: 'Ethereum',
    chainId: '0x1', // 1
    rpcUrl: 'https://ethereum-rpc.publicnode.com',
    fallbackRpcUrls: [
      'https://rpc.ankr.com/eth',
      'https://eth.llamarpc.com'
    ],
    bip44ChainId: 2147483708,
    SHIDO: '0x0e173Bfd28eF21bc460718bcd9b610b7Fcd7F041', // wrapped SHIDO (minted)
    decimals: 18,
    bridge: "0x910cd31c1622160cd84ad67ffd7d16e6f09feb3b",
    icon: '/images/eth.svg',
    explorerUrl: 'https://etherscan.io',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18
    }
  }
};

export const TOKEN_INFO: Record<string, TokenInfo> = {
  'SHIDO': {
    symbol: 'SHIDO',
    name: 'Shido',
    icon: '/images/wshido.png',
    decimals: 18
  }
};

export const FEE_API_BASE_URL = import.meta.env.VITE_FEE_API_URL || 'https://bridge.shido.io';

export const ERC20_ABI = [
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'decimals',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'name',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  },
  {
    type: 'function',
    name: 'symbol',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  }
];

export const BRIDGE_ABI = ShidoBridgeABI;

export const DEFAULT_GAS_LIMIT = 600000;
export const LOCAL_STORAGE_KEY = 'shido-bridge-transactions';
